import type { VocabEntry } from '@/features/api';

import { GlossaryRow } from '../constants';
import {
  getGlossaryLanguageI18nKey,
  SUPPORTED_LANGUAGE_CODES,
} from '../constants/glossaryLanguages';

/**
 * 用語集エントリを辞書保存 API のペイロード形式に変換する。
 *
 * - 言語コードはバックエンド用コードに変換（`jpn` → `ja`）
 * - `soundsLike` → `sounds_like` を明示的に変換
 *   （共通の convertObjectToSneakJson はネストを壊すため使わない）
 * - 読み方が 0 件の語句では `sounds_like` を省略する
 * - 未知の言語コードは除外する（WARN_INVALID_LANG による全体失敗を防ぐ）
 */
export const buildVocabPayload = (
  entries: readonly GlossaryRow[],
): Record<string, VocabEntry[]> => {
  const vocab: Record<string, VocabEntry[]> = {};

  entries.forEach((e) => {
    if (!SUPPORTED_LANGUAGE_CODES.has(e.language)) return;
    const apiCode = getGlossaryLanguageI18nKey(e.language);

    if (!vocab[apiCode]) vocab[apiCode] = [];
    vocab[apiCode].push(
      e.soundsLike.length > 0
        ? { content: e.content, sounds_like: e.soundsLike }
        : { content: e.content },
    );
  });

  return vocab;
};
